'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.FaresOptimizer.Common.FilterAndGroupingUtils', dependencies).factory('RecommendationFilterService', require('./services/RecommendationFilterService'));